---
title: "Términos y condiciones"
path: "/es/terminos-y-condiciones"
seoTitle: "Términos y condiciones | Dutch Passion Thailand"
seoDescription: "Resumen de las condiciones sobre pedidos, pago, entrega y devoluciones al comprar semillas de cannabis Dutch Passion en Tailandia. Léelo antes de pedir."
---

> **Esta versión en español es un resumen y ha sido traducida automáticamente.**
> Solo los [términos y condiciones en inglés](/terms-and-conditions) tienen validez legal. En caso
> de discrepancia, prevalece la versión inglesa. Esta página está pendiente de revisión por un
> hablante nativo.

## Ámbito

Estas condiciones se aplican a todos los pedidos realizados en dutchpassion.co.th. Al confirmar
tu pedido, las aceptas.

## Pedido y pago

Los precios se muestran en bahts tailandeses e incluyen impuestos. Puedes pagar contra reembolso,
con tarjeta de crédito o débito, mediante PromptPay o por banca móvil. Los datos de la tarjeta se
envían directamente a nuestro proveedor Omise y nunca pasan por este sitio.

## Entrega

Los pedidos realizados antes de las 15:00 en día laborable se envían el mismo día. El embalaje es
discreto: nada en el exterior revela el contenido. Solo enviamos dentro de Tailandia: el envío postal
estándar cuesta 100 THB en todo el país, Bangkok incluido, y normalmente llega en 1 a 3 días
laborables. En Bangkok, la entrega en el mismo día está disponible como opción adicional por 250 THB.

## Cancelaciones y devoluciones

Mientras el pedido no se haya enviado, puedes cancelarlo o modificarlo escribiéndonos con tu
número de pedido. Las semillas no admiten devolución, esté o no abierto el paquete, y no se
reembolsan los pedidos entregados. Escríbenos si algún artículo llega defectuoso o no
corresponde a lo pedido.

## Ley aplicable

Estas condiciones se rigen por la legislación tailandesa. Para cualquier duda:
info@dutchpassion.co.th.
